<script setup
        lang="ts"
>
withDefaults(defineProps<{
  variant?: 'contour' | 'rows'
}>(), {
  variant: 'contour'
})

// Unique pattern id per instance so multiple textures on one page don't collide.
const uid = useId()
</script>

<template>
  <div
    class="absolute inset-0 pointer-events-none text-(--ui-border)"
    aria-hidden="true"
    style="-webkit-mask-image: radial-gradient(ellipse 75% 65% at 50% 40%, black 25%, transparent 78%); mask-image: radial-gradient(ellipse 75% 65% at 50% 40%, black 25%, transparent 78%);"
  >
    <svg
      class="absolute inset-0 w-full h-full opacity-[0.5] dark:opacity-[0.3]"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          v-if="variant === 'contour'"
          :id="`ft-${uid}`"
          width="280"
          height="280"
          patternUnits="userSpaceOnUse"
        >
          <g
            fill="none"
            stroke="currentColor"
            stroke-width="1"
          >
            <path d="M-20 60 C 40 20, 90 90, 150 55 S 260 30, 300 70" />
            <path d="M-20 105 C 45 65, 95 130, 155 98 S 255 75, 300 112" />
            <path d="M-20 150 C 50 115, 100 175, 160 145 S 250 125, 300 155" />
            <path d="M-20 200 C 40 170, 95 225, 155 195 S 260 175, 300 205" />
            <path d="M-20 250 C 50 220, 100 270, 160 245 S 250 230, 300 255" />
          </g>
        </pattern>
        <pattern
          v-else
          :id="`ft-${uid}`"
          width="26"
          height="26"
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(-18)"
        >
          <line
            x1="0"
            y1="0"
            x2="0"
            y2="26"
            stroke="currentColor"
            stroke-width="1"
          />
        </pattern>
      </defs>
      <rect
        width="100%"
        height="100%"
        :fill="`url(#ft-${uid})`"
      />
    </svg>
  </div>
</template>
